import React from "react";
import { formatNumber } from "../../../../../Utils/utils";

interface ThirdCardImproveModalityProps {
    improvedData: any;
    quote: boolean;
}

const ThirdCardImproveModality = ({ improvedData, quote }: ThirdCardImproveModalityProps) => {
  return (
    <div className="card-verify verify-approved box-widthout-border ">
      <div className="card-verify__body">
        <div className="card-verify__quote">Renta Vitalicia Pensión:</div>
        <div className="card-verify__data is-label">
          {formatNumber.new(parseFloat(improvedData.primaPensionRv).toFixed(2))}
        </div>
      </div>
      <div className="card-verify__body">
        <div className="card-verify__quote">Renta Temporal:</div>
        <div className="card-verify__data is-label">
          {formatNumber.new(parseFloat(improvedData.primaPensionRt).toFixed(2))}
        </div>
      </div>
      <div className="card-verify__body">
        <div className="card-verify__quote">VAN:</div>
        <div className="card-verify__data is-label">
          {formatNumber.new(parseFloat(improvedData.van).toFixed(2))}
        </div>
      </div>
      <div className="card-verify__body">
        <div className="card-verify__quote">TIR:</div>
        <div className="card-verify__data is-label">
          {formatNumber.new(parseFloat(improvedData.tir).toFixed(2))}
        </div>
      </div>
      <div className="card-verify__body">
        <div className="card-verify__quote">Cesión Comisión:</div>
       <div className="card-verify__data is-label">
          {improvedData.cesionComision}
        </div>
      </div>
      <div className="card-verify__body">
        <div className="card-verify__quote">Cotiza</div>
        <div className="card-verify__data is-label">
          {quote ? "Sí" : "No"}
        </div>
      </div>
    </div>
  );
};

export default ThirdCardImproveModality;
